import { REGION_OPTIONS, ROUTE_PATH } from 'common/constants/sm-constants';
import {
  GridMetaModel,
  Headers,
} from 'common/models/utility-models/meta-model';
import { UploadStudentDocPageModel } from '../upload-student-doc/upload-grid.model';

export class ApplicantsGridMetaModel extends GridMetaModel<Headers> {
  constructor() {
    super(
      'Applicants',
      ROUTE_PATH.applicantGrid,
      ROUTE_PATH.applicants,
      false,
      false,
      8,
      false,
      false,
      ['region', 'stateId', 'branchId', 'rollNoAndName', 'orggender', 'status'],
      true,
      [],
      {
        isDownloadExcel: true,
        excelFileName:
          'Applicant List_' + new Date().toLocaleDateString() + '.xlsx',
        btnLabel: 'Download List',
        headers: [
          { key: 'ID', value: 'id' },
          { key: 'Consider Year', value: 'considerYear' },
          { key: 'Application ID', value: 'applicationId' },
          { key: 'First Name', value: 'firstName' },
          { key: 'Middle Name', value: 'middleName' },
          { key: 'Last Name', value: 'lastName' },
          { key: 'Gender', value: 'gender' },
          { key: 'Age', value: 'age' },
          { key: 'Mobile Number', value: 'mobileNumber' },
          { key: 'Email', value: 'email' },
          { key: 'Alternative Email', value: 'alternativeEmail' },
          { key: 'Father Name', value: 'fatherName' },
          { key: 'Mother Name', value: 'motherName' },
          { key: 'Father Profession', value: 'fatherProfession' },
          { key: 'Mother Profession', value: 'motherProfession' },
          { key: 'Family Annual Income', value: 'familyAnnualIncome' },
          { key: 'Score 10', value: 'score10' },
          { key: 'Score 12', value: 'score12' },
          { key: 'Physics Marks', value: 'physicsMarks' },
          { key: 'Chemistry Marks', value: 'chemistryMarks' },
          { key: 'Mathematics Marks', value: 'mathematicsMarks' },
          { key: 'JEE Score', value: 'jeeScore' },
          { key: 'Institute Name', value: 'instituteName' },
          { key: 'Institute Type', value: 'instituteType' },
          { key: 'Institute Contact', value: 'instituteContact' },
          { key: 'Institute Address', value: 'instituteAddress' },
          { key: 'District', value: 'district' },
          { key: 'City', value: 'city' },
          { key: 'Batch Number', value: 'batch_number' },
          { key: 'Unique Batch ID', value: 'unique_batch_id' },
          { key: 'First Year Fees', value: 'firstYearFees' },
          { key: 'Any Scholarship Name', value: 'anyScholarshipName' },
          { key: 'Offering Institute', value: 'offeringInstitute' },
          { key: 'Scholarship Amount', value: 'scholarshipAmount' },
          { key: 'Organization Name', value: 'orgname' },
          { key: 'Organization Mobile', value: 'orgmobile' },
          { key: 'Organization Gender', value: 'orggender' },
          {
            key: 'Organization Family Annual Income',
            value: 'orgfamilyAnnualIncome',
          },
          { key: 'Organization Physics Marks', value: 'orgphysicsMarks' },
          { key: 'Organization Chemistry Marks', value: 'orgchemistryMarks' },
          {
            key: 'Organization Mathematics Marks',
            value: 'orgmathematicsMarks',
          },
          { key: 'Organization JEE Score', value: 'orgjeeScore' },
          { key: 'Status', value: 'status' },
          { key: 'Status Date', value: 'statusDate' },
          { key: 'Call Count', value: 'callCount' },
          { key: 'Call Status', value: 'callStatus' },
          { key: 'Call Remark', value: 'callRemark' },
          { key: 'Call Remark Date', value: 'callRemarkDate' },
          { key: 'Call Remark By Admin ID', value: 'callRemarkByAdminId' },
          { key: 'Is Rejected', value: 'isRejected' },
          { key: 'Rejected Date', value: 'rejectedDate' },
          { key: 'Created', value: 'created' },
          { key: 'Modified', value: 'modified' },
          { key: 'Is Saved', value: 'isSaved' },
          { key: 'Last Saved Date', value: 'lastSavedDate' },
          { key: 'Assessment Marks', value: 'assessmentMarks' },
          { key: 'Assessment Max Marks', value: 'assessmentMaxMarks' },
          { key: 'Assessment Type', value: 'AssessmentType' },
          { key: 'Assessment Submit Date', value: 'assessmentSubmitDate' },
          { key: 'Interview Score', value: 'interviewScore' },
          { key: 'Interview Status', value: 'interviewStatus' },
          { key: 'Interview Feedback', value: 'interviewFeedback' },
          {
            key: 'Interview Feedback Submit Date',
            value: 'interviewFeedbackSubmitDate',
          },
          { key: 'Home Visit Score', value: 'homeVisitScore' },
          { key: 'Home Visit Total', value: 'homeVisitTotal' },
          {
            key: 'Home Visit Occupation Score',
            value: 'homeVisitOccupationScore',
          },
          {
            key: 'Home Visit Parent Education Score',
            value: 'homeVisitParentEduScore',
          },
          {
            key: 'Home Visit Housing Assets Score',
            value: 'homeVisitHousingAssetsScore',
          },
          {
            key: 'Home Visit Social Skill Score',
            value: 'homeVisitSocialSkillScore',
          },
          { key: 'Home Visit Remark', value: 'homeVisitRemark' },
          { key: 'Home Visit Submit Date', value: 'homevisitSubmitDate' },
          { key: 'All Rank', value: 'AllRank' },
          { key: 'All India Rank', value: 'AllIndiaRank' },
          { key: 'Zone Rank', value: 'ZoneRank' },
          { key: 'State Rank', value: 'StateRank' },
          { key: 'Rank Modified Date', value: 'rankModifiedDate' },
          { key: 'Due Diligence Status Date', value: 'dueDeligenceStatusDate' },
          {
            key: 'Documentation Status Date',
            value: 'documentationStatusDate',
          },
          { key: 'Assessment Status Date', value: 'assessmentStatusDate' },
          { key: 'Interview Status Date', value: 'interviewStatusDate' },
          { key: 'Home Visit Status Date', value: 'homeVisitStatusDate' },
          { key: 'Shortlisting Status Date', value: 'shortlistingStatusDate' },
          { key: 'Shortlisted Status Date', value: 'shortlistedStatusDate' },
          { key: 'Add to Portal Flag', value: 'addToPortalFlag' },
          { key: 'Student ID', value: 'studentId' },
          { key: 'Branch Category Name', value: 'branchCatName' },
          { key: 'Branch Name', value: 'branch_name' },
          { key: 'State Name', value: 'stateName' },
          { key: 'College State Name', value: 'collageStateName' },
          { key: 'Call By Admin Name', value: 'callByAdminName' },
          { key: 'Document Verified Count', value: 'DocVerifiedCount' },
          { key: 'Document Uploaded Count', value: 'DocUploadedCount' },
          { key: 'Total HM Score 11', value: 'TotalHMScore11' },
          { key: 'Total HM Score', value: 'TotalHMScore' },
          { key: 'Call Status Title', value: 'callStatusTitle' },
          { key: 'Total', value: 'Total' },
          { key: 'Status Flag', value: 'statusFlag' },
          { key: 'All Marks Sum', value: 'AllMarksSum' },
          { key: 'Is Resend', value: 'isResend' },
          { key: 'Is All Document Uploaded', value: 'DocUploadedCount' },
          { key: 'Is All Document Verified', value: 'DocVerifiedCount' },
          { key: 'Uploaded Documents', value: 'uploadedDocuments' },
          { key: 'Document Asked Count', value: 'DocAskedCount' },
          { key: 'Alternate Number', value: 'alternate number' },
        ],
      },
      false,
      null,
      false,
      false,
      true,
      null,
      null,
      false,
      null,
      {
        isPreview: false,
        isPreviewType: 'VIDEO',
        isEnvUrl: false,
        linkKey: ['filePath'],
        previewName: '',
      },
      {
        isTabSwitch: false,
        label: '',
        isChecked: false,
      },
      false,
      true,
      true,
      null,
      false,
      {
        isExtraActions: false,
        btnLabel: '',
        selectOptions: [],
        selectedValue: '',
        isPreviewBtn: true,
        previewBtnLabel: 'Preview',
      },
      {
        isCheckboxEmit: true,
        emitKey: 'id',
        checkedKey: '',
        valueKey: '',
      }
    );
  }

  override initProperties() {
    const dataInfo = super.initProperties();
    const bucketData: any = '';
    const checkboxemitArr: any[] = [];
    const formData: any = '';
    const modalData: any = '';
    const editPageData: any = '';
    const editPageMeta: any = '';
    const type: any = '';
    const isAddedToBucket = {};
    const filters = new CardFilter();
    const stateFilerConstant = [];
    // const document:Documentation = new Documentation();
    const uploadExcelModel = new UploadStudentDocPageModel();
    const matchedArray: any[] = [];
    const mapping: any = [];
    const isStudentVerified: any = '';
    const emailEditRow:any = ''
    const newEditedEmail:any = ''
    dataInfo.bucketData = bucketData;
    dataInfo.checkboxemitArr = checkboxemitArr;
    dataInfo.formData = formData;
    dataInfo.modalData = modalData;
    dataInfo.editPageData = editPageData;
    dataInfo.editPageMeta = editPageMeta;
    dataInfo.filters = filters;
    dataInfo.stateFilerConstant = stateFilerConstant;
    dataInfo.isAddedToBucket = isAddedToBucket;
    dataInfo.uploadExcelModel = uploadExcelModel;
    dataInfo.document = document;
    dataInfo.type = type;
    dataInfo.matchedArray = matchedArray;
    dataInfo.mapping = mapping;
    dataInfo.emailEditRow = emailEditRow;
    dataInfo.newEditedEmail = newEditedEmail
    // dataInfo.isStudentVerified = isStudentVerified;
    return dataInfo;
  }

  prepareHeaderList(): Headers[] {
    const headers: Headers[] = [];
    const orgname = new Headers(
      'Full Name',
      'rollNoAndName',
      false,
      false,
      'text'
    );
    const Total = new Headers('Total Score', 'Total', false, false, 'text');
    const AllIndiaRank = new Headers(
      'AIR',
      'AllIndiaRank',
      false,
      false,
      'text'
    );
    const StateRank = new Headers(
      'State Rank',
      'StateRank',
      false,
      false,
      'text'
    );
    const ZoneRank = new Headers(
      'Zonal Rank',
      'ZoneRank',
      false,
      false,
      'text'
    );

    const homeVisitHousingAssetsScore = new Headers(
      'Assets',
      'homeVisitHousingAssetsScore',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );

    const homeVisitOccupationScore = new Headers(
      'Occupation',
      'homeVisitOccupationScore',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );

    const homeVisitParentEduScore = new Headers(
      'Parent Ed',
      'homeVisitParentEduScore',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );

    const homeVisitSocialSkillScore = new Headers(
      'Social Skills',
      'homeVisitSocialSkillScore',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );

    const interviewStatus = new Headers(
      'Interview Remark',
      'interviewStatus',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );

    const assessmentMarks = new Headers(
      'Assessment Marks',
      'assessmentMarks',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );

    const interviewFeedback = new Headers(
      'Feedback',
      'interviewFeedback',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );

    const score10 = new Headers('10th', 'score10', false, false, 'text');
    const score12 = new Headers('12th', 'score12', false, false, 'text');
    const callCount = new Headers(
      'Call Count',
      'callCount',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );
    const callByAdminName = new Headers(
      'Called By',
      'callByAdminName',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );
    const callRemark = new Headers(
      'Remark',
      'callRemark',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );
    const callStatusTitle = new Headers(
      'Last Call Status',
      'callStatusTitle',
      false,
      false,
      'callStatusTitle',
      '0',
      null,
      null,
      null,
      false
    );

    const DocAskedCount = new Headers(
      'Doc Asked',
      'DocAskedCount',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );

    const DocUploadedCount = new Headers(
      'Doc Uploaded',
      'DocUploadedCount',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );

    const DocVerifiedCount = new Headers(
      'Doc Verified',
      'DocVerifiedCount',
      false,
      false,
      'text',
      '0',
      null,
      null,
      null,
      false
    );

    const mobileNumber = new Headers(
      'Contact No.',
      'mobileNumber',
      false,
      true,
      'text'
    );
    const addedApplication = new Headers(
      '',
      '',
      false,
      false,
      'addedApplication'
    );

    const resendDoc = new Headers(
      '',
      'resendDoc',
      false,
      false,
      'resendDoc',
      '0',
      null,
      null,
      null,
      false
    );

    const viewApplication = new Headers(
      '',
      '',
      false,
      false,
      'viewApplication'
    );
    const resetRejectStudent = new Headers(
      '',
      'resetRejectStudent',
      false,
      false,
      'resetRejectStudent',
      // '0',
      // null,
      // null,
      // null,
      // false
    );

    const editStudentDetails = new Headers(
      '',
      'editStudentDetails',
      false,
      false,
      'editStudentDetails',
      '0',
      null,
      null,
      null,
      false
    );

    const editEmail = new Headers(
      '',
      'editEmail',
      false,
      false,
      'editEmail',
      '0',
      null,
      null,
      null,
      true
    );

    headers.push(orgname);
    headers.push(Total);
    headers.push(AllIndiaRank);
    headers.push(StateRank);
    headers.push(ZoneRank);
    headers.push(homeVisitHousingAssetsScore);
    headers.push(homeVisitOccupationScore);
    headers.push(homeVisitParentEduScore);
    headers.push(homeVisitSocialSkillScore);
    headers.push(interviewStatus);
    headers.push(assessmentMarks);
    headers.push(interviewFeedback);
    headers.push(score10);
    headers.push(score12);
    headers.push(callCount);
    headers.push(callByAdminName);
    headers.push(callRemark);
    headers.push(callStatusTitle);
    headers.push(DocAskedCount);
    headers.push(DocUploadedCount);
    headers.push(DocVerifiedCount);
    headers.push(mobileNumber);
    headers.push(addedApplication);
    headers.push(resendDoc);
    headers.push(viewApplication);
    headers.push(editStudentDetails);
    headers.push(resetRejectStudent);
    headers.push(editEmail)
    //   headers.push(viewApplicantsList)
    return headers;
  }
}

export class OpenViewApplicants {
  title: string;
  bindTitle: string[] = [];
  bindKey: String[] = [];
  Values: any[] = [{}];
  isDocument: [];
  isSubTitle: string = '';
}

// export class Documentation
// {
//   documentTypeId: string = '';
//   document_name: string = '';
//   applicant_id: string = '';
//   is_verified: string = '';
//   uploaded: string = '';
//   uploadDocId: string = '';
//   fileName: string = '';
//   fileOriginalName: string = '';
// }

export const documentation: OpenViewApplicants = new OpenViewApplicants();
documentation.title = 'Document';
documentation.isDocument = [];
documentation.isSubTitle = 'Click on thumbnail to view and verify document';

export const rank: OpenViewApplicants = new OpenViewApplicants();
rank.title = 'Ranks';
rank.bindTitle = [
  'Total Score',
  'AIR',
  'State Rank',
  'Zonal Rank',
  '10th',
  '12th',
];
rank.bindKey = [
  'Total',
  'AllIndiaRank',
  'StateRank',
  'ZoneRank',
  'score10',
  'score12',
];
rank.Values = [{}];

export const personalDetails: OpenViewApplicants = new OpenViewApplicants();
personalDetails.title = 'Personal Details';
personalDetails.bindTitle = [
  'Full Name',
  'First Name',
  'Middle Name',
  'Last Name',
  'Gender',
  'Age',
  'Phone',
  'Alternate',
  'Email Id',
  'Alternate Email',
  'City/Town',
  'State/UT of domicile',
  'District',
];
personalDetails.bindKey = [
  'orgname',
  'firstName',
  'middleName',
  'lastName',
  'gender',
  'age',
  'mobileNumber',
  'landlineNumber',
  'email',
  'alternativeEmail',
  'city',
  'stateName',
  'district',
];
personalDetails.Values = [{}];

export const familyDeatails: OpenViewApplicants = new OpenViewApplicants();
familyDeatails.title = 'Family Details';
familyDeatails.bindTitle = [
  "Father's Name",
  "Father's Profession",
  "Mother's Name",
  "Mother's Profession",
  'Family Annual Income',
];
familyDeatails.bindKey = [
  'fatherName',
  'fatherProfession',
  'motherName',
  'motherProfession',
  'familyAnnualIncome',
];
familyDeatails.Values = [{}];

export const academicDetails: OpenViewApplicants = new OpenViewApplicants();
academicDetails.title = 'Acedemic Details';
academicDetails.bindTitle = [
  '10th Std Score',
  '12th Std Score',
  'Physics',
  'Chemistry',
  'Mathematics',
  'JEE/CET Marks',
];
academicDetails.bindKey = [
  'score10',
  'score12',
  'physicsMarks',
  'chemistryMarks',
  'mathematicsMarks',
  'jeeScore',
];
academicDetails.Values = [{}];

export const collegeDetails: OpenViewApplicants = new OpenViewApplicants();
collegeDetails.title = 'College Details';
collegeDetails.bindTitle = [
  'Institute Name',
  'Institute Type',
  'Institute Phone',
  'Branch',
  'Institute Address',
  'First Year Fees',
  'Scholarship Name',
  'Offering Institute',
  'Amount',
  'College State',
];
collegeDetails.bindKey = [
  'instituteName',
  'instituteType',
  'instituteContact',
  'branch_name',
  'instituteAddress',
  'firstYearFees',
  'anyScholarshipName',
  'offeringInstitute',
  'scholarshipAmount',
  'collageStateName',
];
collegeDetails.Values = [{}];

export class PreviePageDetails {
  applied: any[] = [];
  duediligence: any[] = [];
  documentation: any[] = [];
  assessment: any[] = [];
  interview: any[] = [];
  homevisit: any[] = [];
  shortlisting: any[] = [];
  reject: any[] = [];
}

export class ConditionallyVisibleFields {
  applied: String[] = [];
  commanAll: String[] = [
    'orgname',
    'Total',
    'AllIndiaRank',
    'StateRank',
    'ZoneRank',
    'score10',
    'score12',
    'mobileNumber',
    'resetRejectStudent'
  ];
  duedeligence: String[] = [
    'editStudentDetails',
    'callStatusTitle',
    'callCount',
    'callByAdminName',
    'callRemark',
    'callStatusTitle',
  ];
  documentation: String[] = [
    'DocAskedCount',
    'DocUploadedCount',
    'DocVerifiedCount',
    'resendDoc',
  ];
  assessment: String[] = [];
  interview: String[] = ['interviewFeedback'];
  homevisit: String[] = [
    'homeVisitHousingAssetsScore',
    'homeVisitOccupationScore',
    'homeVisitParentEduScore',
    'homeVisitSocialSkillScore',
  ];
  commanKey: String[] = ['assessmentMarks'];
  commanKeyhomeVisit: String[] = ['assessmentMarks', 'interviewStatus'];
  shortlisting: String[] = [];
  reject: String[] = [
    'orgname',
    'Total',
    'AllIndiaRank',
    'StateRank',
    'ZoneRank',
    'score10',
    'score12',
    'mobileNumber',
    'resetRejectStudent',
  ];
}

// export class CardFilter {
//   total: { label: 'Total', values: [] };
// }

export class CardFilter {
  total: { label: string; values: []; total: any } = {
    label: 'Total',
    values: [],
    total: 0,
  };
  selectedRegion: {
    label: string;
    regionCount: any;
    selectedRegion: [];
    currentRegion: string;
  } = {
    label: 'Select Region',
    regionCount: 0,
    selectedRegion: [],
    currentRegion: '',
  };
  selectedState: {
    label: string;
    stateCount: any;
    selectedState: [];
    currentState: string;
  } = {
    label: 'Select State',
    stateCount: 0,
    selectedState: [],
    currentState: '',
  };
  selectedBranch: {
    label: string;
    branchCount: any;
    values: [];
    currentBranch: string;
  } = { label: 'Select Branch', branchCount: 0, values: [], currentBranch: '' };

  selectedBranchCat: {
    label: string;
    branchCatCount: any;
    values: [];
    currentBranch: string;
  } = {
    label: 'Select Branch Category',
    branchCatCount: 0,
    values: [],
    currentBranch: '',
  };

  boys: { label: string; boysCount: any } = { label: 'Boys', boysCount: 0 };
  girls: { label: string; girlsCount: any } = { label: 'Girls', girlsCount: 0 };
  other: { label: string; otherCount: any } = { label: 'Other', otherCount: 0 };
}
